import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ButtonModule } from '@sb/library/button';
import { IconModule } from '@sb/library/icon';
import { UtilityModule } from '@sb/library/utility';
import { StarRatingComponent } from './star-rating.component';
import { LocalizationModule } from '@sb/library/localization';

@NgModule({
    declarations: [StarRatingComponent],
    imports: [CommonModule, IconModule, ButtonModule, UtilityModule, LocalizationModule],
    exports: [StarRatingComponent],
})
export class StarRatingModule {}
